import request from '../../utils/requests'
/** * Tag: WXAppBanner */
const baseUrl ="/api/WXAppBanner";

/** * 新增 * @param {*} body * { *    WXAppBannerId Desc:主键 Required:false *    ImgUrl Desc:图片地址 Required:false *    ReserveImgUrl Desc:预选图片地址 Required:false *    IsOnline Desc:是否上线 Required:false *    Sort Desc:排序 Required:false *    OrgId Desc: Required:false * } */async function _add(body) {  return request(baseUrl+'/add',{    method: 'POST',    body: body,  });
}

/** * 更新 * @param {*} body * { *    WXAppBannerId Desc:主键 Required:false *    ImgUrl Desc:图片地址 Required:false *    ReserveImgUrl Desc:预选图片地址 Required:false *    IsOnline Desc:是否上线 Required:false *    Sort Desc:排序 Required:false *    OrgId Desc: Required:false * } */async function _update(body) {  return request(baseUrl+'/update',{    method: 'POST',    body: body,  });
}

/** * 设置预选图片 * @param {*} body * { *    WXAppBannerId Desc:主键 Required:false *    ImgUrl Desc:图片地址 Required:false * } */async function _setReserveImgUrl(body) {  return request(baseUrl+'/setReserveImgUrl',{    method: 'POST',    body: body,  });
}

/** * 设置轮播图片 * @param {*} body * { *    WXAppBannerId Desc:主键 Required:false *    ImgUrl Desc:图片地址 Required:false * } */async function _setImgUrl(body) {  return request(baseUrl+'/setImgUrl',{    method: 'POST',    body: body,  });
}

/** * 删除单条数据 * @param {*} param * { *    wXAppBannerId Desc:轮播图ID Required:true * } */async function _delete(param) {  return request(baseUrl+'/delete',{    method: 'GET',    params: param,  });
}

/** * 列表查询 * @param {*} body * { *    IsOnline Desc:是否上线 Required:false *    BranchId Desc:校区ID Required:false *    OrgId Desc:机构ID(后台使用) Required:false * } */async function _getList(body) {  return request(baseUrl+'/getList',{    method: 'POST',    body: body,  });
}

export default{  _add,  _update,  _setReserveImgUrl,  _setImgUrl,  _delete,  _getList}



// WEBPACK FOOTER //
// ./src/services/wXAppBanner.js